module.exports = __webpack_public_path__ + "img/warning-square.5c4baf5f.svg";